import {
  hasEditPermission,
  hasReadPermission,
} from '@/utils/hubPermissions/hasPermissions';
import {
  getAllFeatureKeys,
  getAllModuleKeys,
} from '@/utils/hubPermissions/hubPermissionsConfig';
import { deleteCookie, getCookie, setCookie } from 'cookies-next';

export function startImpersonatingUser(org, email) {
  setCookie(
    'impersonatedUser',
    JSON.stringify({
      email,
      org,
    }),
    { sameSite: 'strict' }
  );
}

export function stopImpersonatingUser() {
  deleteCookie('impersonatedUser');
}

export function getImpersonatedUser() {
  return JSON.parse(getCookie('impersonatedUser') || '{}');
}

export function getLeastPermissions(primaryObject, secondaryObject) {
  const leastPermissions = {};

  // Check modules as booleans.
  for (let key of getAllModuleKeys()) {
    leastPermissions[key] = !!(primaryObject[key] && secondaryObject[key]);
  }

  // Check features using off - read - edit system.
  for (let key of getAllFeatureKeys()) {
    if (
      hasEditPermission(primaryObject, key) &&
      hasEditPermission(secondaryObject, key)
    ) {
      leastPermissions[key] = 'edit';
    } else if (
      hasReadPermission(primaryObject, key) &&
      hasReadPermission(secondaryObject, key)
    ) {
      leastPermissions[key] = 'read';
    } else {
      leastPermissions[key] = 'off';
    }
  }

  // We keep any non module/feature keys from the primary object.
  return {
    ...primaryObject,
    ...leastPermissions,
  };
}

export function hasImpersonationPermission(user, org) {
  return (
    hasReadPermission(user, 'administrationUserImpersonation') &&
    hasReadPermission(org, 'administrationUserImpersonation')
  );
}
